import { memo } from 'react';
import { COMMENT_INDICATOR_IDENTIFIER } from 'collaboration-sidebar/constants/identifiers';
import { View } from 'foundations-components/transitional/components/View';
import EmbeddedCommentIndicator from './EmbeddedCommentIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
function EmbeddedComment({
  onClose,
  collaborationSidebarState,
  verticalPositioning,
  setIsCommenting,
  iconPosition = {},
  iconProps,
  renderCommentIndicator,
  moduleParentComment,
  topOffset,
  leftOffset,
  isOpen,
  embeddedCommentWrapperRef,
  toggleOpenPopover
}) {
  return /*#__PURE__*/_jsx(View, {
    id: COMMENT_INDICATOR_IDENTIFIER,
    position: "absolute",
    insetBlockStart: iconPosition.top || `${topOffset}px`,
    insetInlineStart: iconPosition.left || `${leftOffset}px`,
    insetBlockEnd: iconPosition.bottom,
    insetInlineEnd: iconPosition.right,
    children: /*#__PURE__*/_jsx(EmbeddedCommentIndicator, {
      collaborationSidebarState: collaborationSidebarState,
      isOpen: isOpen,
      onClose: onClose,
      iconProps: iconProps,
      renderCommentIndicator: renderCommentIndicator,
      setIsCommenting: setIsCommenting,
      verticalPositioning: verticalPositioning,
      hasCustomPosition: Object.keys(iconPosition).length > 0,
      moduleParentComment: moduleParentComment,
      embeddedCommentWrapperRef: embeddedCommentWrapperRef,
      toggleOpenPopover: toggleOpenPopover
    })
  });
}
export default /*#__PURE__*/memo(EmbeddedComment);